// extracted by mini-css-extract-plugin
module.exports = {"root":"Heroshot_root__8j_u3"};